"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1079.397 -141.546)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1079.397 141.546)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1091.4,165.547a12,12,0,1,1,12-12A12.014,12.014,0,0,1,1091.4,165.547Zm0-23.041a11.04,11.04,0,1,0,11.04,11.04A11.054,11.054,0,0,0,1091.4,142.506Z",
    transform: "translate(-1079.397 -141.546)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1082.474 148.906)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1100.714,153.388a.611.611,0,0,0-.08-.121.624.624,0,0,0-.2-.133.624.624,0,0,1,.2.133A.611.611,0,0,1,1100.714,153.388Z",
    transform: "translate(-1083.315 -149.369)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1100.782,153.943a.6.6,0,0,0,.007-.421A.6.6,0,0,1,1100.782,153.943Z",
    transform: "translate(-1083.328 -149.384)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1099.445,155.311l1.15-1.15a.6.6,0,0,0,.133-.2.6.6,0,0,1-.133.2Z",
    transform: "translate(-1083.275 -149.402)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1099.651,153.273l-2.3,2.3h0Z",
    transform: "translate(-1083.191 -149.374)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1100.729,159.115a.6.6,0,0,0-.133-.2l-1.15-1.15,1.15,1.15A.6.6,0,0,1,1100.729,159.115Z",
    transform: "translate(-1083.275 -149.554)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1100.195,160.026a.6.6,0,0,0,.43-.178.6.6,0,0,0,.133-.2.6.6,0,0,1-.133.2A.6.6,0,0,1,1100.195,160.026Z",
    transform: "translate(-1083.305 -149.629)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1100.782,159.628a.607.607,0,0,0,0-.457A.607.607,0,0,1,1100.782,159.628Z",
    transform: "translate(-1083.328 -149.61)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1086.34,154.468a.684.684,0,0,0-.2.03.679.679,0,1,0,.2-.03Z",
    transform: "translate(-1082.724 -149.422)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1100.177,160.035a.606.606,0,0,1-.43-.178A.6.6,0,0,0,1100.177,160.035Z",
    transform: "translate(-1083.287 -149.637)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1094.508,160.035a.606.606,0,0,0,.43-.178.606.606,0,0,1-.43.178Z",
    transform: "translate(-1083.078 -149.637)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1100.185,153.088a.612.612,0,0,0-.229.044.612.612,0,0,1,.229-.044Z",
    transform: "translate(-1083.296 -149.367)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1094.508,153.088h0a.61.61,0,0,1,.43.178A.61.61,0,0,0,1094.508,153.088Z",
    transform: "translate(-1083.078 -149.367)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none ",
    d: "M1097.351,157.461l2.3,2.3-2.3-2.3Z",
    transform: "translate(-1083.191 -149.542)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e80000 ",
    d: "M1088.062,154.548a1.854,1.854,0,1,0-.131,1.412A1.852,1.852,0,0,0,1088.062,154.548Zm-1.172.863a.676.676,0,1,1-.8-.962.679.679,0,0,1,.847.447A.672.672,0,0,1,1086.89,155.411Z",
    transform: "translate(-1082.675 -149.373)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e80000 ",
    d: "M1100.506,158.928a.6.6,0,0,0-.133-.2l-1.15-1.15-1.15-1.15,1.15-1.15,1.15-1.15a.589.589,0,0,0,.14-.621.542.542,0,0,0-.06-.118.611.611,0,0,0-.08-.121.624.624,0,0,0-.2-.133.6.6,0,0,0-.229-.044.612.612,0,0,0-.229.044.622.622,0,0,0-.2.133l-2.3,2.3h0l-1.334-1.334-.863-.864-.1-.1a.61.61,0,0,0-.86,0,.6.6,0,0,0-.159.334.557.557,0,0,0-.019.1.6.6,0,0,0,.179.43l1.135,1.135,1.165,1.165-2.3,2.3a.608.608,0,0,0,.86.86l2.3-2.3h0l2.3,2.3a.61.61,0,0,0,.86,0,.6.6,0,0,0,.133-.2A.607.607,0,0,0,1100.506,158.928Z",
    transform: "translate(-1083.052 -149.367)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e80000 ",
    d: "M1100.074,150.649a.591.591,0,0,0-.287-.347l-1.582-.835a.592.592,0,0,0-.448-.041l-5.809,1.8a5.226,5.226,0,1,0,1.1,3.542l.339-.1.487.256-.606-.6a1.083,1.083,0,0,1-.314-.75l-.659.2a.588.588,0,0,0-.415.575,4.05,4.05,0,1,1-.653-2.11.587.587,0,0,0,.666.242l5.983-1.85.846.446-.447.847-.975.3a.586.586,0,0,0-.347.287l-.282.535-.534-.281a.585.585,0,0,0-.448-.042l-.716.223,1.133,1.133.538.283a.581.581,0,0,0,.477.025.588.588,0,0,0,.318-.271l.052-.1.39-.741.508-.157.468-.144a.591.591,0,0,0,.347-.288l.1-.188.736-1.394A.592.592,0,0,0,1100.074,150.649Z",
    transform: "translate(-1082.602 -149.212)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1094.49,160.035h0a.605.605,0,0,1-.43-.178A.605.605,0,0,0,1094.49,160.035Z",
    transform: "translate(-1083.06 -149.637)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1100.726,153.4a.542.542,0,0,1,.06.118A.542.542,0,0,0,1100.726,153.4Z",
    transform: "translate(-1083.326 -149.379)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1094.956,159.761l2.3-2.3h0Z",
    transform: "translate(-1083.096 -149.542)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1100.195,153.088a.6.6,0,0,1,.229.044A.6.6,0,0,0,1100.195,153.088Z",
    transform: "translate(-1083.305 -149.367)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1095.194,155.351h0l1.165,1.165-2.3,2.3,2.3-2.3Z",
    transform: "translate(-1083.06 -149.457)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1094.06,153.266a.609.609,0,0,1,.43-.178A.609.609,0,0,0,1094.06,153.266Z",
    transform: "translate(-1083.06 -149.367)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1097.3,155.614h0l-1.335-1.335h0Z",
    transform: "translate(-1083.136 -149.415)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1095.057,153.375h0l-.1-.1Z",
    transform: "translate(-1083.096 -149.374)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1094.053,153.273a.6.6,0,0,0-.159.334h0A.6.6,0,0,1,1094.053,153.273Z",
    transform: "translate(-1083.053 -149.374)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1094.06,154.169l1.135,1.135h0Z",
    transform: "translate(-1083.06 -149.41)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1093.893,153.621a.557.557,0,0,0-.019.1.557.557,0,0,1,.019-.1Z",
    transform: "translate(-1083.052 -149.388)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff ",
    d: "M1095.062,153.379l.864.864h0l-.864-.864Z",
    transform: "translate(-1083.1 -149.379)"
  }))));
};

exports["default"] = _default;